import BaseProxy from "../../base-proxy";

/**
 * @class UpdateInvoicesProxy
 * @description Class used for communicating PUT requests with invoices API.
 * @author Yves Gonzaga
 * @version 1.0
 * @since October 25, 2021
 */
export default class CreateInvoicesProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.skippedEntries - Skipped entries.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/invoices/${data.id}/create/`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
